const colunasBase: { nome: string; exibir: boolean }[] = [
  { nome: "empresa", exibir: true },
  { nome: "exercicio", exibir: true },
  { nome: "placa", exibir: true },
  { nome: "renavam", exibir: true },
  { nome: "chassi", exibir: true },
  { nome: "solicitacao", exibir: true },
  { nome: "vencimento", exibir: true },
  { nome: "valor", exibir: true },
  { nome: "status", exibir: true },
  { nome: "statusProcesso", exibir: true },
];

export const defaultConfigColunasAguardando = colunasBase;

export const defaultConfigColunasPago = [
  ...colunasBase,
  { nome: "pagamento", exibir: true },
];

export const defaultConfigColunas = defaultConfigColunasPago;
